import React, { useState, useContext } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import SummaryApi from "../../common/index";
import { UserContext } from "../../context/UserContext";
import "../../Styles/UserStylings/Login.css";
 
const { Title } = Typography;
 
const UserLogin = () => {
  const [activeTab, setActiveTab] = useState("password");
  const [form] = Form.useForm();
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
 
  const navigate = useNavigate();
  const { login, fetchProfile } = useContext(UserContext);
 
  const loginSendOtp = async () => {
    const mobile_number = form.getFieldValue("mobile");
    if (!mobile_number || !/^\d{10}$/.test(mobile_number)) {
      return message.warning("Enter a valid 10-digit mobile number!");
    }
    try {
      setLoading(true);
      const res = await axios.post(SummaryApi.loginSendOtp.url, { mobile_number });
      if (res.data.success) {
        message.success("OTP sent successfully!");
        setOtpSent(true);
      } else {
        message.error(res.data.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("Send OTP Error:", err);
      message.error(err.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
 
  const onFinish = async (values) => {
    try {
      let res;
      if (activeTab === "password") {
        // Password Login
        res = await axios.post(SummaryApi.signin.url, {
          email: values.email,
          password: values.password,
        });
      } else {
        // OTP Login (Verify MSG91 OTP)
        res = await axios.post(SummaryApi.verifyotp.url, {
          mobile_number: values.mobile,
          otp: values.otp,
        });
      }
      if (res.data.success) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        login(res.data.user, res.data.token);
        await fetchProfile();
        message.success("Login successful!");
        form.resetFields();
        setOtpSent(false);
        navigate("/");
      } else {
        message.error(res.data.message || "Login failed");
      }
    } catch (err) {
      console.error("Login Error:", err);
      message.error(err.response?.data?.message || "Login failed, try again!");
    }
  };
 
  return (
    <div className="login-container">
      <Title level={3} className="login-title">Login</Title>
      <div className="login-tabs">
        <button
          className={activeTab === "password" ? "active" : ""}
          onClick={() => {
            setActiveTab("password");
            setOtpSent(false);
            form.resetFields();
          }}
        >
          Password Login
        </button>
        <button
          className={activeTab === "otp" ? "active" : ""}
          onClick={() => {
            setActiveTab("otp");
            setOtpSent(false);
            form.resetFields();
          }}
        >
          OTP Login
        </button>
      </div>
      <Form form={form} layout="vertical" onFinish={onFinish} className="login-form">
        {activeTab === "password" ? (
          <>
            <Form.Item label="Email" name="email" rules={[{ required: true, message: "Email is required" }]}>
              <Input placeholder="Enter your email" />
            </Form.Item>
            <Form.Item label="Password" name="password" rules={[{ required: true, message: "Password is required" }]}>
              <Input.Password placeholder="Enter your password" />
            </Form.Item>
            {/* Add "Forgot password?" link */}
            <div style={{ textAlign: "right", marginBottom: "15px" }}>
              <Link to="/forgot-password" style={{ fontSize: "14px" }}>
                Forgot Password?
              </Link>
            </div>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Login
              </Button>
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item label="Mobile Number" name="mobile" rules={[{ required: true, message: "Mobile number is required" }]}>
              <Input placeholder="Enter mobile number" maxLength={10} />
            </Form.Item>
            {otpSent && (
              <Form.Item label="OTP" name="otp" rules={[{ required: true, message: "Please enter OTP" }]}>
                <Input placeholder="Enter OTP" />
              </Form.Item>
            )}
            {/* Show only one button at a time */}
            <Form.Item>
              {!otpSent ? (
                <Button
                  type="primary"
                  block
                  onClick={loginSendOtp}
                  loading={loading}
                  style={{ marginBottom: "10px" }}
                >
                  Send OTP
                </Button>
              ) : (
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={loading}
                  style={{ marginBottom: "10px" }}
                >
                  Verify OTP
                </Button>
              )}
            </Form.Item>
          </>
        )}
      </Form>
    </div>
  );
};
 
export default UserLogin;
 